import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { ContractProvider } from '../providers/contract.provider';
import { DisinvestmentInterface, OrderClientInterface } from '../data';
import { Transaction } from '../transaction/transaction';
import { TransferProvider } from '../providers/transfer-provider.service';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface SignDisinvestmentUseCaseParams {
    signatories: OrderClientInterface[];
    disinvestment: DisinvestmentInterface;
}

@Injectable()
export class SignDisinvestmentUseCase implements UseCaseWithParam<SignDisinvestmentUseCaseParams, Observable<Transaction<boolean>>> {
    constructor(private contractProvider: ContractProvider, private transferProvider: TransferProvider) {}

    bind(params: SignDisinvestmentUseCaseParams): Observable<Transaction<boolean>> {
        return this.contractProvider.current().pipe(
            switchMap((transaction) =>
                transaction.map(
                    (contract) => this.transferProvider.signDisinvestment(contract.encryptedCode, params.signatories, params.disinvestment),
                    (throwable) => of(Transaction.error(throwable.message))
                )
            )
        );
    }
}
